// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_select__basicSelect__1Mptt {
    height: 1.8rem;
    max-width: 8rem;
    flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./src/components/BasicSelect/styles.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB","sourcesContent":[".select__basicSelect {\n    height: 1.8rem;\n    max-width: 8rem;\n    flex-wrap: wrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select__basicSelect": `styles_select__basicSelect__1Mptt`
};
export default ___CSS_LOADER_EXPORT___;
